/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getAppHistory } from '../../../../../../store/reducers/application/applicationAction';

const ApplicationHistory = ({ selectedApplication }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const applicationHistory = useSelector(state => state.application.applicationHistory)
    useEffect(() => {
        dispatch(getAppHistory({ "applicationID": selectedApplication.applicationID }));
    }, [dispatch, selectedApplication]);
    useEffect(() => {
        setHistoryList([])
        if (applicationHistory?.length > 0) {
            applicationHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.applicationName,
                        details: element.Record.applicationDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }])
            });
        }
    }, [applicationHistory]);

    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Application  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default ApplicationHistory;